<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="fr01">
<h2 class="center2">Also by Alexander Mikaberidze</h2>
<p class="center1"><em class="italic">Lion of the Russian Army:</em></p>
<p class="center0"><em class="italic">Life and Career of General Peter Bagration</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// therussian_fr01.vue?05526e11